import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Menu,
  MenuItem,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Menu as MenuIcon, KeyboardArrowDown } from '@mui/icons-material';

const Header: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleProductsMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  const navigationItems = [
    { label: 'Home', path: '/', onClick: () => handleNavigation('/') },
    { 
      label: 'Insurance Products', 
      hasDropdown: true,
      dropdownItems: [
        { label: 'Auto Insurance', path: '/auto-insurance' },
        { label: 'Home Insurance', path: '/home-insurance' },
        { label: 'Business Insurance', path: '/business-insurance' },
        { label: 'Life Insurance', path: '/life-insurance' },
      ]
    },
    { label: 'About Us', path: '/about', onClick: () => handleNavigation('/about') },
    { label: 'Claims', path: '/claims', onClick: () => handleNavigation('/claims') },
    { label: 'Customer Portal', path: '/customer-portal', onClick: () => handleNavigation('/customer-portal') },
    { label: 'Contact', path: '/contact', onClick: () => handleNavigation('/contact') },
  ];

  if (isMobile) {
    return (
      <>
        <AppBar position="static" sx={{ backgroundColor: '#470271', boxShadow: 'none' }}>
          <Toolbar>
            <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 700, color: 'white' }}>
              Mostly Safe Insurance (MSI)
            </Typography>
            <IconButton 
              edge="end" 
              color="inherit" 
              onClick={() => setMobileMenuOpen(true)}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Drawer 
          anchor="right" 
          open={mobileMenuOpen} 
          onClose={() => setMobileMenuOpen(false)}
        >
          <List sx={{ width: 250 }}>
            {navigationItems.map((item) => (
              <ListItem 
                key={item.label} 
                button 
                onClick={() => {
                  if (item.onClick) item.onClick();
                  setMobileMenuOpen(false);
                }}
              >
                <ListItemText primary={item.label} />
              </ListItem>
            ))}
          </List>
        </Drawer>
      </>
    );
  }

  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: '#470271', boxShadow: 'none' }}>
        <Toolbar sx={{ padding: '1rem 2rem' }}>
          <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 700, fontSize: '1.5rem', color: 'white' }}>
            Mostly Safe Insurance (MSI)
          </Typography>
          
          <Box sx={{ display: 'flex', gap: 1 }}>
            {navigationItems.map((item) => (
              <Box key={item.label}>
                {item.hasDropdown ? (
                  <>
                    <Button
                      color="inherit"
                      onClick={handleProductsMenu}
                      endIcon={<KeyboardArrowDown />}
                      sx={{ 
                        color: 'white', 
                        fontSize: '1rem',
                        textTransform: 'none',
                        '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
                      }}
                    >
                      {item.label}
                    </Button>
                  </>
                ) : (
                  <Button
                    color="inherit"
                    onClick={item.onClick}
                    sx={{ 
                      color: 'white', 
                      fontSize: '1rem',
                      textTransform: 'none',
                      '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
                    }}
                  >
                    {item.label}
                  </Button>
                )}
              </Box>
            ))}
            
            <Button
              variant="contained"
              sx={{ 
                backgroundColor: '#1A92C0',
                color: 'white',
                fontSize: '1rem',
                textTransform: 'none',
                '&:hover': { backgroundColor: '#136B8C' }
              }}
            >
              Get a Quote
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        sx={{ mt: 1 }}
      >
        <MenuItem onClick={handleCloseMenu}>Auto Insurance</MenuItem>
        <MenuItem onClick={handleCloseMenu}>Home Insurance</MenuItem>
        <MenuItem onClick={handleCloseMenu}>Business Insurance</MenuItem>
        <MenuItem onClick={handleCloseMenu}>Life Insurance</MenuItem>
      </Menu>
    </>
  );
};

export default Header;